module.exports = __webpack_public_path__ + "09529765f146917c6af9c58bf2a43c26.svg";